import { ThemeDirection } from '@chakra-ui/theme';

// Left to right
export const direction: ThemeDirection = 'ltr';
